import React from "react";

export const Divider = ({ className }: { className?: string }) => {
  return (
    <div
      className={`cw-w-full cw-border-b cw-border-solid cw-border-subtle cw-my-1 ${className}`}
    />
  );
};
